<script lang="ts">
  import { onDestroy, onMount } from "svelte";

  let parentElement:HTMLElement

  onMount(()=> {
    document.body.addEventListener("mousedown", onMouseDown);
    document.body.addEventListener("keydown", onKeyDown);
  });

  onDestroy(()=> {
    document.body.removeEventListener("mousedown", onMouseDown);
    document.body.removeEventListener("keydown", onKeyDown);
  });

  function onMouseDown() {
    parentElement.classList.remove("keyboard-focus");
  }
    
  function onKeyDown(event:KeyboardEvent) {
    if (event.key === "Tab") {
      parentElement.classList.add("keyboard-focus");
    }
  }
</script>

<div bind:this={parentElement}>
  <slot></slot>
</div>

<style>
  :global(.keyboard-focus) {
    @apply outline-none;
  }
</style>
